import { IPromoOffersState } from '../../types/promoOffersSelection';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EPromoOffersActionTypes {
  UpdateFavorite = 'PROMO_OFFERS/UPDATE_FAVORITE',
  SetOffers = 'PROMO_OFFERS/SET_OFFERS',
}

interface IUpdateFavoritePayload {
  offerId: number;
  isFavorite: boolean;
}

export type TUpdateFavorite = ITypedReduxAction<EPromoOffersActionTypes.UpdateFavorite, IUpdateFavoritePayload>;

export const updateFavorite = actionGenerator<EPromoOffersActionTypes.UpdateFavorite, IUpdateFavoritePayload>(
  EPromoOffersActionTypes.UpdateFavorite,
);

export type TSetPromoOffers = ITypedReduxAction<EPromoOffersActionTypes.SetOffers, IPromoOffersState>;

export const setPromoOffers = actionGenerator<EPromoOffersActionTypes.SetOffers, IPromoOffersState>(
  EPromoOffersActionTypes.SetOffers,
);

export type TPromoOffersActions = TUpdateFavorite | TSetPromoOffers;
